import ConfigureApp from "./amplifyConfig";

// Gen2: config comes from amplify_outputs.json and Amplify is configured
// app-side (see ./amplifyConfig). The shared-auth `ConfigureApp` is bypassed —
// it only understands the Gen1 aws-exports shape.
ConfigureApp();
